/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CheckRegResponseApiRoaming } from '../../models/check-reg-response-api-roaming';

export interface ApiRoamingCheckRegGet$Params {

/**
 * Customer phone number.
 */
  phoneNumber?: string;

/**
 * Request language.
 */
  lang?: string;
}

export function apiRoamingCheckRegGet(http: HttpClient, rootUrl: string, params?: ApiRoamingCheckRegGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CheckRegResponseApiRoaming>> {
  const rb = new RequestBuilder(rootUrl, apiRoamingCheckRegGet.PATH, 'get');
  if (params) {
    rb.query('phoneNumber', params.phoneNumber, {});
    rb.query('lang', params.lang, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CheckRegResponseApiRoaming>;
    })
  );
}

apiRoamingCheckRegGet.PATH = '/api/Roaming/CheckReg';
